import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React from 'react';
import { Input } from '../Input/Input';

/**
 * `InputEmail` provides mobile users with the appropriate keyboard for easy data entry.
 */
export var InputEmail = function InputEmail(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Email address' : _ref$label,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Input, _extends({
    label: label
  }, otherProps, {
    type: "email"
  }));
};